<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-form>
              <b-row>
                <b-col
                  cols="6"
                  sm="3"
                >
                  <b-form-group
                    label-for="schoolYearId"
                  >
                    <v-select
                      id="schoolYearId"
                      v-model="filter.schoolYearId"
                      :options="schoolYears"
                      :reduce="option => option.value"
                      placeholder="Chọn năm học"
                      @input="onSchoolYearsChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="6"
                  sm="4"
                >
                  <b-form-group
                    title="Khóa - Học kỳ"
                    label-for="courseSemesterId"
                  >
                    <v-select
                      id="courseSemesterId"
                      v-model="filter.courseSemesterId"
                      :options="courseSemesterSubjectOptions"
                      :reduce="(option) => option.value"
                      placeholder="Khóa - Học kỳ"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  sm="5"
                  class="text-sm-right text-center"
                >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="onSearchMainData"
                  >
                    <feather-icon icon="FilterIcon" /> Lọc
                  </b-button>
                  <b-button
                    v-if="selectedRowTable.length > 0 && updatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="ml-1"
                    @click="onGrantMainData('grant')"
                  >
                    <feather-icon icon="UserCheckIcon" /> Gán quyền
                  </b-button>
                  <b-button
                    v-if="selectedRowTable.length > 0 && updatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="danger"
                    class="ml-1"
                    @click="onGrantMainData('revoke')"
                  >
                    <feather-icon icon="UserMinusIcon" /> Gỡ quyền
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
            <b-row class="mt-0">
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-0">
                  <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                    đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                  </span>
                </div>
                <vue-good-table
                  mode="remote"
                  :columns="columns"
                  :rows="mainData"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  line-numbers
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :select-options="{
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                  @on-selected-rows-change="selectionChanged($event)"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'action'">
                      <b-button-group>
                        <b-button
                          v-if="updatable"
                          variant="info"
                          class="btn-icon"
                          size="sm"
                        >
                          <feather-icon icon="InfoIcon" />
                        </b-button>
                      </b-button-group>
                    </span>

                    <span v-else-if="props.column.field === 'isGranted'"
                          :class="props.row.isGranted?'text-success':'text-danger'">
                      {{ getStatusName(props.row.isGranted) }}
                    </span>
                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BFormGroup,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
  BForm,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import { getUser } from '@/auth/utils'
import { GRANT_STATUS } from '@/const/status'

export default {
  name: 'Supervisor',
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BButton,
    BButtonGroup,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
    vSelect,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        organizationId: getUser().orgId,
        departmentId: null,
        schoolYearId: null,
        courseSemesterId: null,
        isGrant: null,
        name: null,
        sort: null,
      },
      currentMainData: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      selectedRowTable: [],
    }
  },
  computed: {
    ...mapGetters({
      mainData: 'account/supervisors',
      totalRows: 'account/totalSupervisor',
      schoolYears: 'dropdown/schoolYears',
      coursesSemesters: 'examinationRoom/coursesSemesters',
    }),
    columns() {
      return [
        {
          label: 'Tên Giám thị',
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: 'Năm học',
          field: 'schoolYearName',
          sortable: false,
          width: '120px',
          thClass: 'text-center',
        },
        {
          label: 'Khóa-học kỳ',
          field: 'courseName',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: 'Khoa/Bộ môn',
          field: 'departmentName',
          filterOptions: {
            enabled: false,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: 'Trạng thái',
          field: 'isGranted',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '60px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.GRANT_SUPERVISOR)
    },
    courseSemesterSubjectOptions() {
      return this.coursesSemesters.map(item => ({
        value: item.id,
        label: item.name,
      }))
    },
  },
  async created() {
    this.isLoading = true
    try {
      await this.getSchoolYears()
      await this.getMainDataStore()
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      getMainData: 'account/getSupervisors',
      getSchoolYears: 'dropdown/getSchoolYears',
      getCourseSemesters: 'examinationRoom/getCourseSemesters',
      grantSupervisor: 'account/grantSupervisor',
      revokeSupervisor: 'account/revokeSupervisor',
    }),
    isSystemAdmin,
    /* Common VGT */
    onEditExaminationRoom(examinationRoom) {
      const {
        rowNum, originalIndex, vgt_id, ...rest
      } = examinationRoom
      this.currentMainData = rest
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getMainDataStore()
    },
    async getMainDataStore() {
      this.isLoading = true
      try {
        await this.getMainData(this.filter)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getMainDataStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'name') this.updateParams({ sort: `1_${type}` })
        else if (field === 'code') this.updateParams({ sort: `2_${type}` })
        else this.updateParams({ sort: `3_${type}` })
      }
      await this.getMainDataStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ code: columnFilters.code })
      await this.getMainDataStore()
    },
    async onSucceed() {
      await this.getMainDataStore()
    },
    selectionChanged(event) {
      this.selectedRowTable = event.selectedRows
    },
    /* END - Common VGT */
    getStatusName(value) {
      const found = GRANT_STATUS.find(e => e.value === value)
      if (!found) return ''
      return found.label
    },
    async onSchoolYearsChange() {
      const request = { year_id: this.filter.schoolYearId }
      await this.getCourseSemesters(request)
    },
    async onSearchMainData() {
      await this.getMainDataStore()
    },
    async onGrantMainData(action) {
      let confirmText = ''
      let confirmHint = ''
      if (action === 'grant') {
        confirmText = 'Bạn chắc chắn muốn gán vai trò giám thị cho các cán bộ này?'
        confirmHint = 'Cán bộ sẽ có quyền xử lý vi phạm thi với các phòng thi được phân công!'
      } else {
        confirmText = 'Bạn chắc chắn muốn gỡ vai trò giám thị cho các cán bộ này?'
        confirmHint = 'Cán bộ sẽ không thể xử lý vi phạm thi với các phòng thi được phân công!'
      }
      this.$swal({
        title: confirmText,
        text: confirmHint,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            const request = { accountId: this.selectedRowTable.map(item => (item.id)).join(',') }
            const response = (action === 'grant')
              ? await this.grantSupervisor(request)
              : await this.revokeSupervisor(request)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                try {
                  await this.getMainDataStore()
                } catch (e) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `[${e.code}] ${e.message}`,
                      icon: 'XCircleIcon',
                      variant: 'danger',
                    },
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
